import { useState } from 'react'
import { Button } from '@chakra-ui/react'
import ConfirmActionDialog from '@/components/ConfirmActionDialog'

const DeactivateAgendaButton = () => {
  const [open, setOpen] = useState(false)

  const handleConfirm = () => {
    console.log('Implementação do método de desativação ainda está sendo feita.')
    setOpen(false)
  }

  return (
    <>
      <Button
        colorPalette="red"
        size={{ base: 'xs', sm: 'sm' }}
        onClick={() => setOpen(true)}
        disabled
      >
        Desativar
      </Button>

      {open && (
        <ConfirmActionDialog
          open={open}
          onOpenChange={setOpen}
          size="md"
          title="Desativar agenda"
          body="Tem certeza que deseja desativar esta agenda? Esta ação não poderá ser desfeita."
          onConfirm={handleConfirm}
          confirmColorPalette="red"
        />
      )}
    </>
  )
}

export default DeactivateAgendaButton
